<div id="canton" class="page-layout carded fullwidth" fusePerfectScrollbar>

  <!-- TOP BACKGROUND -->
  <div class="top-bg mat-accent-bg"></div>
  <!-- / TOP BACKGROUND -->

  <!-- CENTER -->
  <div class="center">

    <!-- HEADER -->
    <div class="header white-fg" fxLayout="row" fxLayoutAlign="space-between center">

      <!-- APP TITLE -->
      <div fxLayout="row" fxLayoutAlign="start center">

        <button class="mr-0 mr-sm-16" mat-icon-button [routerLink]="'/pages/settings/modules'">
          <mat-icon>arrow_back</mat-icon>
        </button>

        <mat-icon class="logo-icon mr-16" *fuseIfOnDom >apps</mat-icon>

        <div fxLayout="column" fxLayoutAlign="start start"
          *fuseIfOnDom>
          @if (!id) {
            <div class="h2">
              {{'module.newModule' | translate}}
            </div>
          }
          @if (id) {
            <div class="h2">
              {{'module.editModule' | translate}}
            </div>
          }
          <div class="subtitle secondary-text">
            <span>{{'module.moduleDetail' | translate}}</span>
          </div>
        </div>
      </div>
      <!-- / APP TITLE -->
      <div>
        @if (id) {
          <button mat-raised-button
            class="save-product-button mat-white-bg mt-16 mt-sm-0"
            (click)="enable()">
            @if (id) {
              <span>{{'enable_to_all' | translate}}</span>
            }
          </button>
        }
        <button mat-raised-button
          class="save-product-button mat-white-bg mt-16 mt-sm-0"
          [disabled]="formGroup && formGroup.invalid" (click)="addModule(true)">
          @if (!id) {
            <span>{{'main.add' | translate}}</span>
          }
          @if (id) {
            <span>{{'main.update' | translate}}</span>
          }
        </button>
      </div>

    </div>
    <!-- / HEADER -->

    <!-- CONTENT CARD -->
    <div class="content-card mat-white-bg">

      <!-- CONTENT -->
      <div class="content">
        <form [formGroup]="formGroup">
          <mat-checkbox formControlName="status"
            [labelPosition]="'after'">
            {{'module.active' | translate}}
          </mat-checkbox>
          <mat-form-field>
            <input matInput placeholder="{{'module.title' | translate}}" formControlName="title">
          </mat-form-field>
          <mat-form-field>
            <textarea matInput placeholder="{{'module.description' | translate}}" formControlName="description"
            cdkTextareaAutosize cdkAutosizeMinRows="3"></textarea>
          </mat-form-field>
          <mat-form-field>
            <input matInput placeholder="{{'module.url' | translate}}" formControlName="url">
          </mat-form-field>
          <mat-form-field style="width: 48%;">
            <mat-label>{{'Page' | translate}}</mat-label>
            <mat-select formControlName="pageId" required>
              @for (page of pages; track page.id) {
                <mat-option [value]="page.id">
                  {{page?.title}}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </form>
      </div>
      <!-- / CONTENT -->

    </div>
    <!-- / CONTENT CARD -->

  </div>
  <!-- / CENTER -->
</div>
